let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("e1cuZ"), load("6kXh6"), load("9u8bR")]).then(() => parcelRequire('5w2FB'));